import React, {Component, PropTypes} from 'react';
import {
  Row,
  Col,
  Grid,
  Panel,
  PanelBody,
  PanelHeader,
  FormControl,
  PanelContainer,
  Icon,
  Button,
  PanelFooter,
  Form,
  FormGroup,
  HelpBlock,
  ControlLabel,
} from '@sketchpixy/rubix';

import RoleType from '../../../RoleGroup/Roles/RoleType';
import {checkRole} from '../../../../util/RoleChecker';
import {getRoles, getServiceRegion, getRoleGroupDetail, updateRoleGroup} from '../../../../api/api';
import {routeUrl} from '../../../routeUrl';
import Roles from './Roles/Roles';
import _ from 'lodash';

class EditRoleGroup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: 'Create Role Group',
      editButtonName: 'Create',
      roles: [],
      serviceRegions: [],
      roleGroupName: '',
      roleGroupKey: '',
      roleGroupDescription: '',
      roleLocalePairs: [],
    };
  }

  componentDidMount() {
    const requiredRoles = [
      RoleType.PERMISSION_GROUP,
    ];

    checkRole(requiredRoles, this.props.router);

    Messenger.options = {
      theme: 'flat',
    };

    if (this.props.editMode) {
      const roleGroupId = this.props.params.roleGroupId;
      getRoleGroupDetail(roleGroupId, (err, result) => {
        if (err) {
          this.props.router.push(routeUrl.login);
        } else {
          let roleLocalePairs = this.state.roleLocalePairs;

          result.roles.map(role => {
            roleLocalePairs.push({
              roleId: role.roleId,
              countryCode: role.region,
            });
          });

          this.setState({
            roleLocalePairs,
            roleGroupName: result.roleGroup.roleGroupName,
            roleGroupKey: result.roleGroup.roleGroupKey,
            roleGroupDescription: result.roleGroup.roleGroupDescription,
          });
        }
      });

      this.setState({
        title: 'Edit Role Group',
        editButtonName: 'Update',
      });
    }

    getRoles((err, result) => {
      if (err) {
        this.props.router.push(routeUrl.login);
      } else {
        this.setState({
          roles: result.roles,
        });
      }
    });

    getServiceRegion((err, result) => {
      if (err) {
        this.props.router.push(routeUrl.login);
      } else {
        this.setState({
          serviceRegions: result.list,
        });
      }
    });
  }

  roleGroupNameChangeHandler = (event) => {
    this.setState({
      roleGroupName: event.target.value,
    });
  };
  
  roleGroupKeyChangeHandler = (event) => {
    this.setState({
      roleGroupKey: event.target.value,
    });
  };

  roleGroupDescriptionChangeHandler = (event) => {
    this.setState({
      roleGroupDescription: event.target.value,
    });
  };

  roleMappedChangeHandler = (roleId, countryCode) => {
    let roleLocalePairs = this.state.roleLocalePairs;
    const index = _.findIndex(roleLocalePairs, {roleId});
    if (index < 0) {
      roleLocalePairs.push({
        roleId,
        countryCode: countryCode,
      });
    } else {
      roleLocalePairs.splice(index, 1);
    }

    this.setState({
      roleLocalePairs,
    });
  };

  localeChangeHandler = (roleId, countryCode) => {
    let roleLocalePairs = this.state.roleLocalePairs;
    const index = _.findIndex(roleLocalePairs, {roleId});
    if (index >= 0) {
      roleLocalePairs[index].countryCode = countryCode;
    }

    this.setState({
      roleLocalePairs,
    });
  };

  goBack = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.router.goBack();
  };

  updateRoleGroup = () => {
    if (this.state.roleGroupName.length === 0) {
      return alert('Please input role group name.');
    }

    let roleGroupId = null;
    if (this.props.editMode) {
      roleGroupId = this.props.params.roleGroupId;
    }
    const roleGroupName = this.state.roleGroupName;
    const roleGroupKey = this.state.roleGroupKey;
    const roleGroupDescription = this.state.roleGroupDescription;
    const roleLocalePairs = this.state.roleLocalePairs;
    updateRoleGroup(roleGroupId, roleGroupName, roleGroupKey, roleGroupDescription, roleLocalePairs, (err, result) => {
      if (err) {
        this.props.router.push(routeUrl.login);
      } else {
        this.props.router.goBack();
      }
    });

  };

  render() {
    return (
        <PanelContainer controls={false}>
          <Panel>
            <PanelHeader className='bg-pinkishred fg-white'>
              <Grid>
                <Row>
                  <Col xs={12}>
                    <h3>
                      <Icon glyph='icon-fontello-edit' />
                      &nbsp; {this.state.title}
                    </h3>
                  </Col>
                </Row>
              </Grid>
            </PanelHeader>
            <PanelBody>
              <Grid>
                <Row>
                  <Col xs={12}>
                    <Form>
                      <FormGroup controlId='name'>
                        <ControlLabel>Name</ControlLabel>
                        <FormControl
                            type="text"
                            placeholder="Enter Role Group Name"
                            value={this.state.roleGroupName}
                            onChange={this.roleGroupNameChangeHandler}
                        />
                        <HelpBlock>Specify a permission name.</HelpBlock>
                      </FormGroup>
                      <FormGroup controlId='name'>
                          <ControlLabel>Key</ControlLabel>
                          <FormControl
                              type="text"
                              placeholder="Enter Role Group Key"
                              value={this.state.roleGroupKey}
                              onChange={this.roleGroupKeyChangeHandler}
                          />
                          <HelpBlock>Specify a group key.</HelpBlock>
                      </FormGroup>

                      <FormGroup controlId='description'>
                        <ControlLabel>Description</ControlLabel>
                        <FormControl
                            type="text"
                            placeholder="Enter Role Group Description"
                            value={this.state.roleGroupDescription}
                            onChange={this.roleGroupDescriptionChangeHandler}
                        />
                        <HelpBlock>Optional.</HelpBlock>
                      </FormGroup>
                    </Form>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <ControlLabel>Roles</ControlLabel>
                    <Roles
                        roles={this.state.roles}
                        serviceRegions={this.state.serviceRegions}
                        roleLocalePairs={this.state.roleLocalePairs}
                        roleMappedChangeHandler={this.roleMappedChangeHandler}
                        localeChangeHandler={this.localeChangeHandler}
                    />
                  </Col>
                </Row>
              </Grid>
            </PanelBody>
            <PanelFooter className='bg-pinkishred'>
              <Grid>
                <Row>
                  <Col xs={12} className='fg-white'>
                    <div style={{marginTop: '15px', marginBottom: '15px', float: 'right'}}>
                      <Button bsStyle='brownishgray' onClick={this.goBack} style={{marginRight: '8px'}}>Cancel</Button>
                      <Button bsStyle='brownishgray' onClick={this.updateRoleGroup}>
                        {this.state.editButtonName}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Grid>
            </PanelFooter>
          </Panel>
        </PanelContainer>
    );
  }
}

EditRoleGroup.propTypes = {};

export default EditRoleGroup;



// WEBPACK FOOTER //
// ./src/routes/permission/RoleGroups/RoleGroup/EditRoleGroup.js